
<br><br><br><br><br>
<p>Titulo : {{titulo | uppercase | camelCase }}</p>
<p>Data : {{data | date}}</p>
<p>preço : {{preco }}</p>
